import { SkuDTO } from '@/types/api/sku';

export default async function getSimilarProducts(
  slug: string
): Promise<SkuDTO[]> {
  try {
    const response = await fetch(`/api/get-similar-products`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ slug }),
    });
    if (!response.ok) throw new Error('Error loading similar products');
    return response.json();
  } catch (e) {
    throw new Error('Error loading similar products');
  }
}
